var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicSlashThin = function SvgMicSlashThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.6a3.9 3.9 0 0 0-3.9 3.9v6c0 1.06.422 2.022 1.109 2.725L7.583 15.85a6.2 6.2 0 0 1-1.783-4.35V10a.4.4 0 1 0-.8 0v1.5a7 7 0 0 0 2.017 4.916l-3.55 3.55a.4.4 0 0 0 .325.68L19.97 4.47a.747.747 0 0 1 .314-.188l.248-.25a.4.4 0 0 0-.565-.565l-4.068 4.068V5.5A3.9 3.9 0 0 0 12 1.6Zm3.1 6.735V5.5a3.1 3.1 0 1 0-6.2 0v6c0 .84.333 1.601.875 2.16l5.324-5.325Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.9 10.661-.8.8v.04a3.1 3.1 0 0 1-3.14 3.099l-.725.725A3.9 3.9 0 0 0 15.9 11.5v-.839Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.422 17.139-.6.599A7 7 0 0 0 19 11.5V10a.4.4 0 0 0-.8 0v1.5a6.2 6.2 0 0 1-8.778 5.639Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.6c.22 0 .4.18.4.4v2a.4.4 0 0 1-.8 0v-2c0-.22.178-.4.4-.4Z"
  })));
};
export default SvgMicSlashThin;